import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.count = 0;
        this.max = 4;
        this.field = this.$( 'field' )[0];

        this.targets = document.querySelectorAll( '[data-accompany]' );

        this.$( 'minus' )[0].addEventListener( 'click', () => {
            if( this.count === 0 ) return;
            this.count--;
            this.update();
        });

        this.$( 'plus' )[0].addEventListener( 'click', () => {
            if( this.count === this.max ) return;
            this.count++;
            this.update();
        });

        /*this.el.addEventListener( 'change', () => {

        });*/
    }

    reset(){
        this.count = 0;
        this.update();
    }

    update(){
        this.el.classList.toggle( 'no-less', this.count === 0 );
        this.el.classList.toggle( 'no-more', this.count === this.max );

        this.field.value = this.count;

        for( let  i = 0 ; i < this.targets.length; i++ ){
            this.targets[ i ].classList.toggle( 'hidden', i + 1 > this.count );
            this.targets[ i ].dataset.validateGroup = i + 1 <= this.count ? 'true' : 'false';
        }
        this.call( 'update', false, 'Scroll');
    }
}
